type MaskedIconProps = {
  iconUrl: string;
  fadePercentage: number;
  bgColor?: string;
};

export const MaskedIcon = ({
  iconUrl,
  fadePercentage,
  bgColor,
}: MaskedIconProps) => (
  <div className="m:relative m:-mt-2 m:flex m:flex-col m:items-center">
    <div
      className="m:absolute m:top-0 m:left-0 m:inline-block m:h-6 m:w-6 m:bg-warmgrey-100 m:dark:bg-blue-850"
      style={{
        maskImage: `url("${iconUrl}")`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "50% 50%",
      }}
    />
    <div
      className={`m:inline-block m:h-6 m:w-6 ${bgColor}`}
      style={{
        background: `linear-gradient(to top, rgba(255, 214, 81) ${fadePercentage}%, transparent ${fadePercentage}%)`,
        maskImage: `url("${iconUrl}")`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "50% 50%",
      }}
    />
  </div>
);
